<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">{{ taker ? 'Edit' : 'Add'}} taker</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-6">
                        <el-form-item class="gcmcn-form-input" prop="name">
                            <div class="gcmcn-form-label">Name</div>
                            <el-input
                                size="mini"
                                v-model="form.name"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-3">
                        <upload-file
                            style="margin-top: 20px;"
                            text="Upload thumbnails"
                            :default-image="defaultImage"
                            :imageSize="{width: '58px', height: '58px'}"
                            @image-uploaded="onCropImage"
                        ></upload-file>
                    </div>
                    <div class="flex-basis-10">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="aws_region_uid"
                        >
                            <div class="gcmcn-form-label">AWS Region</div>
                            <el-select
                                v-model="form.aws_region_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder="Select a region"
                            >
                                <el-option
                                    v-for="region in awsregionsSortedByName"
                                    :key="region.uid"
                                    :label="region.display_name"
                                    :value="region.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-10">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="entity_uid"
                        >
                            <div class="gcmcn-form-label">Entity</div>
                            <el-select
                                v-model="form.entity_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder="Select an entity"
                                :disabled="disabledEntity"
                            >
                                <el-option
                                    v-for="entity in entities"
                                    :key="entity.uid"
                                    :label="entity.display_name"
                                    :value="entity.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-10">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="client_identifier"
                        >
                            <div class="gcmcn-form-label">Client ID</div>
                            <el-input
                                v-model="form.client_identifier"
                                size="mini"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="taker?updateTaker():validateForm()">Save
                    </el-button>
                </div>
            </el-form>
        </div>
        <cropper-modal
            ref="cropper"
            @on-image-cropped="onImageCropped"
            title="Configure taker image"
        >
            <ul class="crop-rules">
                <li>Image formats allowed are jpeg, jpg and png.</li>
                <li>Best ratio 1:1</li>
                <li>Minimal image size allowed is 100 x 100</li>
            </ul>
        </cropper-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
    CropperModal,
    UploadFile,
} from 'gcmcn-common';
export default {

    components: {
        CropperModal,
        UploadFile,
    },

    props: {
        takerUid: {
            type: String,
            required: true,
        },
        takersWithId: {
            type: Array,
            required: false,
            default:()=> {
                return [];
            },
        },
    },

    data (){
        return {
            form: {
                name: '',
                aws_region_uid: '',
                entity_uid: '',
                logo: '',
                client_identifier: '',
            },
            loading: false,
            defaultImage: '',
            defaultTakerLogo: '../../../../static/image/default-taker-logo.png',
        };
    },

    computed: {
        ...mapGetters([
            'takersByUid',
            'awsregionsSortedByName',
            'entities',
        ]),
        rules () {
            return {
                name: [{ required: true, validator: this.authorizedCharacters }],
                aws_region_uid: [{ required: true, message: 'AWS region is required' }],
                entity_uid: [{ required: this.taker ? false : true }],
                client_identifier: [{ validator: this.validateIdentifier }],
            };
        },

        taker (){
            return this.takersByUid(this.takerUid);
        },
        disabledEntity(){
            if(this.taker){
                return true;
            }
            return false;
        },
        existingTakerIdlist(){
            let filteredTakerList = this.takersWithId.filter(taker => taker.scopes.entity_uid === this.form.entity_uid);
            return filteredTakerList.map(taker => taker.client_identifier);
        }
    },

    watch: {
        taker: {
            handler (){
                this.setForm();
            },
            deep: true,
            immediate: true,
        },
    },

    created (){
    },

    methods: {

        onCropImage (data){
            this.$refs.cropper.open(data, {
                aspectRatio: 1,
                minCropBoxWidth: 100,
                minCropBoxHeight: 100,
            });
        },
        async onImageCropped (croppedImage){
            const url = croppedImage;
            const file = await this.$store.dispatch('createBlobFromUrl', {imageUrl: url, addBackgroundToImage: false});
            this.form.logo = file;
            this.defaultImage = croppedImage;
        },

        async createBlobFromUrl (imageUrl){
            const url = imageUrl;
            let logoFile = await fetch(url)
                .then(res => res.blob())
                .then(async blob => {
                    let fileWithBg = await this.$store.dispatch('addBackgroundToImageOnUpload', blob);
                    return fileWithBg.file;
                });
            return logoFile;
        },

        setForm (){
            if(this.taker){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.taker)));
                this.defaultImage = this.form.logo;
                this.$set(this.form, 'entity_uid', this.taker.scopes.entity_uid);
            }else{
                this.$set(this, 'form', {
                    name: '',
                    aws_region_uid: '',
                    entity_uid: '',
                    client_identifier: '',
                    logo: '',
                });
            }
        },
        validateIdentifier (rule, value, callback) {
            if(this.takersWithId){
                if(this.existingTakerIdlist.includes(this.form.client_identifier)){
                    return callback(new Error('Taker ID is already used.'));
                }
            }
            callback();
        },
        authorizedCharacters(rules, value, callback) {
            if(!this.form.name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.name.match(this.$store.getters.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        updateTaker(){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let logo = this.form.logo;
                    delete form.logo;
                    delete form.entity_uid;
                    let postData = {
                        item: {
                            taker_uid: this.taker.uid,
                        },
                        model: 'takerModificationRequests',
                        url: this.$store.state.api.meta.listModels.takerModificationRequests.url,
                        scopes: {'X-Entity-Uid': this.form.scopes.entity_uid},
                    };
                    Object.entries(form).forEach(([key, value])=>{
                        if(['name','aws_region_uid','client_identifier'].includes(key)){
                            // we set request data based on changes from taker data
                            // if data hasn't change we return empty string
                            postData.item[key] = this.taker[key] === value?'':value;
                        }
                    });
                    this.$store.dispatch('createItem', postData).then(res => {
                        this.$store.dispatch('fundation/watchRequestStatus',{
                            url: res.url,
                        }).then(response =>{
                            // Request success
                            this.handleLogo(this.taker, logo)
                            .then(()=>{
                                let message = 'Taker edited!';
                                let type = 'success';
                                if(response.data.verbose_status !== ''){
                                    type = 'warning';
                                    message = response.data.verbose_status;
                                }
                                this.$message({
                                    message: message,
                                    type: type
                                });
                                this.$emit('on-taker-created');
                                this.loading = false;
                            }).catch(e=>{
                                console.error(e);
                                this.$message.error('Error while editing taker logo, please retry');
                                this.loading = false;
                            });
                        }).catch(response => {
                            this.loading = false;
                            this.$message({
                                message: response.data.verbose_status,
                                type: 'error'
                            });
                        });
                    });
                }
            });
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let logo = this.form.logo;
                    let postData = { item: form, model: 'takers'};
                    delete form.logo;
                    form.can_admin_users = [this.$store.getters.currentUser.uid];
                    postData.url = this.$store.state.api.meta.listModels.takers.url;
                    postData.scopes = {'X-Entity-Uid': this.form.entity_uid};

                    this.$store.dispatch('createItem', postData).then( async (res) => {
                        // alors le champs logo du form est vide, on lui set une image par défaut

                        // cette ligne permet d'empecher l'apparition des rules au save d'un taker (voir https://git.netsach.info/globecast/gcmcn/support/-/issues/68)
                        this.$refs.form.clearValidate();
                        if(logo === '' || logo === null){
                            logo = await this.$store.dispatch('createBlobFromUrl', {imageUrl: this.defaultTakerLogo, addBackgroundToImage: false});
                        }
                        this.handleLogo(res, logo).then(()=>{
                            this.$message({
                                message: 'Taker created!',
                                type: 'success'
                            });
                            this.$emit('on-taker-created');
                            this.loading = false;
                        }).catch((e)=>{
                            // close taker form since it's already created and notify user there is an error
                            console.error(e);
                            this.$message.error('Error while adding taker logo');
                            this.$emit('on-taker-created');
                            this.loading = false;
                        });
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error('Error on taker creation.');
                        this.loading = false;
                    });
                }
            });
        },
        handleLogo(taker, logo){
            /*
                Used by validateForm() and updateTaker()
                for updateTaker(), isCreate is false we return Promise to handle
                notification logic inside the method
            */
            if(typeof(logo) === 'string'){
                return Promise.resolve();
            }else{
                let fd = new FormData();
                fd.append('logo', logo);
                return this.$store.dispatch('patchItemFormData', {
                    item: fd,
                    url: taker.url,
                    model: 'takers',
                }).then(() => {
                    return Promise.resolve();
                }).catch((e) => {
                    return Promise.reject(e);
                });
            }
        },
        leave (){
            this.$emit('leave-form-view');
        },

        async createDefaultTakerImage (){
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            ctx.canvas.width  = 100;
            ctx.canvas.height = 100;
            ctx.fillStyle = 'rgb(155, 155, 155)';
            ctx.fillRect(0, 0, 100, 100);
            const image = await new Promise((resolve) => {
                canvas.toBlob(async function(blob) {
                    const file = new File([blob], 'default-taker-logo.png', {
                        type: blob.type,
                    });
                    resolve(file);
                });
            });
            return image;
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Takers/taker-form.vue